import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Layout from '../components/Layout';
import api from '../components/api';

// Composants refactorisés
import ProcesVerbalStatsCards from '../components/soutenance/proces/ProcesVerbalStatsCards';
import ProcesVerbalDetailsTab from '../components/soutenance/proces/ProcesVerbalDetailsTab';
import PrintHeaderProcesVerbal from '../components/soutenance/proces/PrintHeaderProcesVerbal';
import PrintContentProcesVerbal from '../components/soutenance/proces/PrintContentProcesVerbal';
import PageHeaderProcesVerbal from '../components/soutenance/proces/PageHeaderProcesVerbal';

const DetailsProceVerbal = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [procesVerbal, setProcesVerbal] = useState(null);
  const [etablissement, setEtablissement] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [procesVerbalResponse, etablissementResponse] = await Promise.all([
          api.get(`/soutenance/proces-verbaux/${id}/`),
          api.get('/etablissement/etablissement-infos/')
        ]);
        
        // Normalisation des données
        const procesVerbalData = procesVerbalResponse.data.data || procesVerbalResponse.data;
        const etablissementData = etablissementResponse.data.data || etablissementResponse.data;
        
        setProcesVerbal(procesVerbalData);
        setEtablissement(etablissementData);
        
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error);
        toast.error('Erreur lors du chargement des données');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // Fonction d'impression
  const handlePrint = () => {
    window.print();
  };

  // Affichage du chargement
  if (loading) {
    return (
      <Layout>
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#202654]"></div>
            <span className="ml-3 text-gray-600">Chargement des données...</span>
          </div>
        </div>
      </Layout>
    );
  }

  // Affichage en cas d'erreur
  if (!procesVerbal || !etablissement) {
    return (
      <Layout>
        <div className="container mx-auto px-4 py-8">
          <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
            <h1 className="text-2xl font-bold text-gray-900">Procès-verbal non trouvé</h1>
            <p className="mt-2 text-gray-600">Le procès-verbal que vous recherchez n'existe pas ou a été supprimé.</p>
            <button
              onClick={() => navigate('/soutenance')}
              className="mt-4 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#202654] hover:bg-[#202654]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654]"
            >
              Retour à la liste
            </button>
          </div>
        </div>
      </Layout>
    );
  }

  // Affichage principal
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 print:p-0 print:m-0 print-ready">
        <div id="proces-verbal-details" className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden print:border-0 print:shadow-none print:rounded-none">
          
          {/* En-tête d'écran - caché en impression */}
          <PageHeaderProcesVerbal 
            procesVerbal={procesVerbal} 
            navigate={navigate} 
            handlePrint={handlePrint} 
          />

          {/* Contenu principal */}
          <div className="p-6 print:p-0">
            
            {/* DÉBUT CONTENU IMPRESSION */}
            <div className="print-container">
              {/* En-tête d'impression */}
              <PrintHeaderProcesVerbal etablissement={etablissement} procesVerbal={procesVerbal} />

              {/* Contenu principal pour l'impression */}
              <PrintContentProcesVerbal procesVerbal={procesVerbal} />
            </div>
            {/* FIN CONTENU IMPRESSION */}

            {/* DÉBUT CONTENU ÉCRAN */}
            <div className="screen-container print:hidden">
              {/* Titre et description du procès-verbal */}
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Procès-verbal de soutenance</h2>
                <div className="text-gray-600">
                  <p className="mb-2">
                    <span className="font-medium">Type:</span> {procesVerbal?.soutenance?.type_soutenance?.nom || 'Non défini'}
                  </p>
                  <p className="mb-2">
                    <span className="font-medium">Statut:</span> {procesVerbal?.valide ? 'Validé' : 'Brouillon'}
                  </p>
                  {procesVerbal?.soutenance?.titre_travail && (
                    <div className="mt-3 text-gray-700">
                      <p><span className="font-medium">Titre du travail:</span> {procesVerbal.soutenance.titre_travail}</p>
                    </div>
                  )}
                </div>
              </div>
                                
              {/* Cartes de statistiques */}
              <ProcesVerbalStatsCards procesVerbal={procesVerbal} />

              {/* Détails avec design amélioré */}
              <div className="mt-8">
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                  <ProcesVerbalDetailsTab procesVerbal={procesVerbal} />
                </div>
              </div>
            </div>
            {/* FIN CONTENU ÉCRAN */}

          </div>
        </div>
      </div>
      <div className="hidden print:block mt-8"></div>
    </Layout>
  );
};

export default DetailsProceVerbal; 